<template>
  <div class="login_container">
    <RegisterInner></RegisterInner>
  </div>
</template>
<script>
import { translateTitle } from "@/assets/js/i18n";
import RegisterInner from "@/pages/login/register-inner.vue";
export default {
  mixins: [],

  data() {
    return {};
  },
  components: { RegisterInner },
  computed: {
    // ...mapGetters({
    //   darkMode: "user/darkMode"
    // })
  },
  created() {},
  beforeDestroy() {},
  destroyed() {},
  mounted() {},
  methods: {
    translateTitle,
  },
};
</script>
<style lang="scss"></style>
